import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import FilterBar from "../../../components/molecule/filter-bar/filter-bar";
import { AgGridAtom, ModalAtom } from '../../../components/atoms/atom';
import {  getManufactureTableColumns } from './constant';
import { getSearchAddFilter } from '../../../utils/get-filter-items';
import { searchData } from '../../../utils/search';
import { setting } from '../../../store/services/index';
import { showToast, getFormattedDate, showError } from '../../../utils/method';
import SettingsMenu from '../settings-menu/settings-menu';
import AddManufactureModal from './add/add-manufacture';
import { AuthContext } from "../../../contexts/AuthProvider";
    
function ResourceManufacturePage() {
    const { t } = useTranslation();
    const { helpMode } = useContext(AuthContext);
    const [manufactureModalView, setManufactureModalView] = useState('');
    const [selectedManufacture, setSelectedManufacture] = useState({});
    const [showDeleteModal, setShowdeleteModal] = useState(false);
    const filterItems = getSearchAddFilter(t, { addTextKey: 'add-manufacture' });
    const [leftFilterItems, setLeftFilterItems] = useState(filterItems.left || []);
    const [rightFilterItems] = useState(filterItems.right || []);
    const [manufactureList, setManufactureList] = useState([]);
    const [filterdManufactureList, setFilterdManufactureList] = useState([]);
    const navigate = useNavigate();

    const fetchManufactures = async () => {
        try{
            let result = await setting.getResourceManufacture();
            result = (result?.data || []).map((record) => {
                return {
                    ...record,
                    provided: getFormattedDate(record.createdAt)
                }
            })
            setManufactureList(result);
            setFilterdManufactureList(result);
        } catch(error){
            showError(t, error);
        }
    }
    
    useEffect(() => {
        fetchManufactures();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    const onManufactureEdit = (row, rowIndex) => {
        setSelectedManufacture(row);
        setManufactureModalView('edit');
    };

    const onManufactureDelete = (row, rowIndex) => {
        setSelectedManufacture(row);
        setShowdeleteModal(true);
    }

    const onDeleteManufacture = async () => {
        try {
            const res = await setting.deleteResourceManufacture(selectedManufacture?.id);
            showToast(t(res?.message), { type: 'success' });
            fetchManufactures();
            setShowdeleteModal(false);
        } catch(error) {
            showToast(t(error?.message), { type: 'error' });
        }
    }

    const onAddManufacture = async (manufactureInfo) => {

        try{
            if (manufactureModalView === 'add') {
                const res = await setting.addResourceManufacture({
                    name: manufactureInfo.name
                });
                showToast(t(res?.message), { type: 'success' });
            } else if (manufactureModalView === 'edit') {
                const res = await setting.updateResourceManufacture({
                    name: manufactureInfo.name
                }, manufactureInfo.id);
                showToast(t(res?.message), { type: 'success' });
            }  
            fetchManufactures();
            setManufactureModalView('');  
        } catch(error){
            showToast(t(error?.message), { type: 'error' });
        }

    }
    const manufactureColumns = getManufactureTableColumns(t, onManufactureEdit, onManufactureDelete, helpMode);

    const onFilterAction = (index, key, info) => {
        if (key === 'search') {
            const localLeftFilterItems = [...leftFilterItems];
            localLeftFilterItems[1].value = info?.value;
            setLeftFilterItems(localLeftFilterItems);
            const filteredRoleList = searchData(info?.value, manufactureList, manufactureColumns);
            setFilterdManufactureList(filteredRoleList);
        }
        if (key === 'add') {
            setSelectedManufacture({});
            setManufactureModalView('add');
        }
        if (key === 'back') {
            navigate(-1);
        }
    };

    return (
        <>
            <SettingsMenu />
            <FilterBar 
                leftItems={leftFilterItems}
                rightItems={rightFilterItems}
                onFilterAction={onFilterAction} />

            <AgGridAtom 
                columnDefs={manufactureColumns}
                rowData={filterdManufactureList}
            />

            {manufactureModalView && <AddManufactureModal
                mode={manufactureModalView}
                manufactureInfo={selectedManufacture}
                show
                onClose={() => {setManufactureModalView('');  setSelectedManufacture('')} }
                onSubmit={onAddManufacture}
            />}
            <ModalAtom 
                title={t('delete-manufacture')} 
                body={<p>{t('delete-manufacture-warning')}</p>}
                saveText = "delete"
                show={showDeleteModal} 
                handleClose={() => setShowdeleteModal(false) }
                handleSubmit={onDeleteManufacture}
            />
        </>
    );
}

export default ResourceManufacturePage;
